import { createApp } from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import scroll from "vue3-seamless-scroll";

// Element Plus UI library
import ElementPlus from 'element-plus'
import 'element-plus/dist/index.css'

// Global base styles
import '@/styles/init.css'

// Global theme styles (must be after Element Plus to override defaults)
import '@/styles/theme.scss'

// Lazy-load directive for images
import Lazyload from "vue3-lazyload";

// NOTE: amfe-flexible was removed. The layout is px + media queries and
// postcss-pxtorem is disabled, so rewriting html{font-size} had no effect.

createApp(App).use(store).use(router).use(ElementPlus).use(Lazyload).use(scroll).mount('#app')
